import React from 'react';
import _ from 'lodash';
import Button from '../../../../../core/web/js/button/Button';

import backgrounds from '../../../json/backgrounds';

import '../../../css/background.css';

import StatLine from './StatLine';
import Powers from './Powers'


/**
 *
 */
function Background(props){
  const statPickCount = Object.keys(props.state.statChoices).length;
  const selectedBackground = backgrounds.filter(data=>{
    return data.type===props.state.background;
  })[0];
  return (
    <div className="background">
      <div className="statModifications">
      <b>Stat Modifications</b>
      <ul>
        {_renderStatModifications(props)}
      </ul>
      </div>


      <b>Stat Choices</b> - Pick {selectedBackground.statPoints - statPickCount}<br />
      <ul>
        {_renderStatChoices(props)}
      </ul>

      <b>Stat-line</b><br />
      <StatLine stats={props.state} />

      <b>Powers</b>
        {_renderPowerCards(props)}
    </div>
  );
}


/**
 *
 */
function _renderStatModifications(props){
  const selectedBackground = backgrounds.filter(data=>{
    return data.type===props.state.background;
  })[0];

  const modKeys = Object.keys(selectedBackground.statModifications);
  const statModifications = modKeys.map(statName=>{
    const stat = selectedBackground.statModifications[statName];
    const key = "stat_"+statName;
    return (<li key={key}>{statName.slice(0,1).toUpperCase()+statName.slice(1)} +{stat}</li>);
  });
  return statModifications;
}


/**
 *
 */
function _renderStatChoices(props){
  const selectedBackground = backgrounds.filter(data=>{
    return data.type===props.state.background;
  })[0];

  const statPickCount = Object.keys(props.state.statChoices).length;
  const choiceKeys = Object.keys(selectedBackground.statChoices);
  const statChoices = choiceKeys.map(statName=>{
    const stat = selectedBackground.statChoices[statName];
    const key = "stat_"+statName;
    let text = statName.slice(0,1).toUpperCase()+statName.slice(1)+" +"+stat;
    let selected = false;

    // check if stat choice is already in list
    if(props.state.statChoices[statName]){
      text = (<b>{text}</b>);
      selected = true;
    }

    if(statPickCount < selectedBackground.statPoints || selected){
      return (<li key={key}><Button onClick={_clickStatChoice.bind(this, props, statName)} type="link">{text}</Button></li>);
    }else{
      return (<li key={key}><span className="buttonSpacer">{text}</span></li>);
    }
  });
  return statChoices;
}


/**
 *
 */
function _clickStatChoice(props, statName){
  const selectedBackground = backgrounds.filter(data=>{
    return data.type===props.state.background;
  })[0];
  const statValue = selectedBackground.statChoices[statName];

  //check if selected stat is not in existing list of choices
  if(!props.state.statChoices[statName]){
    let state = _.cloneDeep(props.state);
    state.statChoices[statName] = statValue;
    state[statName] += statValue;
    props.updateState(props.stateName, state);
  }else{
    let state = _.cloneDeep(props.state);
    delete state.statChoices[statName];
    state[statName] -= statValue;
    props.updateState(props.stateName, state);
  }
}


/**
 *
 */
function _renderPowerCards(props){
  const selectedBackground = backgrounds.filter(data=>{
    return data.type===props.state.background;
  })[0];

  return (
    <Powers data={selectedBackground.corePowers} />
  );
}

export default Background;
